module.exports = {
      id: "ic-15-1s-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-15-1s-index-usage",
      toString: function () {
        return this.url;
      }
    }